<template>
  <v-tooltip bottom>
    <template v-slot:activator="{on}">
      <v-btn
          v-on="on"
          v-if="isVisible"
          small icon
          color="blue white--text"
          @click="fetchDoc" class="mb-2">
        <v-icon>difference</v-icon>
      </v-btn>
    </template>
    Certificado Precancelación
  </v-tooltip>

</template>

<script>
import FileBuilderProvider from "@/modules/cobrox/providers/FileBuilderProvider";

export default {
  name: "CertificadoPrecancelacionFileButton",
  props: {
    ticket: {type: Object}
  },
  computed: {
    isVisible() {
      if (this.ticket.tracker.name === 'Certificado precancelacion' && ['Aprobado'].includes(this.ticket.status.name)) {
        return true
      }
      return false
    }
  },
  methods: {
    fetchDoc() {
      FileBuilderProvider.buildCertificadoPrecancelacionPdf(this.ticket.id)
          .then(r => {
            setTimeout(() => window.open(r.data.buildCertificadoPrecancelacionPdf), 300)
          })
    },

  }
}
</script>

<style scoped>

</style>
